export default {
    'upload_file': 'Загрузить файл',
    'upload_file_title': 'Нажмите или перетащите файл с компьютера, чтобы загрузить его',
    'upload_file_description': 'Вы можете загрузить файлы PNG, SVG. Максимальный размер: 5 GB',
    'remove': 'Удалить',
    'save_files': 'Сохранить',
    'file_uploaded_successfully': 'Файл успешно загружен',
    'file_deleted_successfully': 'Файл успешно удалён',
    'enter_your_message': 'Напишите ваше сообщение...',
};
